export const UPDATE_CATEGORY_DATA='CATEGORYPAGE/UPDATE_CATEGORY_DATA'

export const CATEGORY_URL = "/bus/:category-bus-services/"
